/**
 * Option item with matched-character bolding for PW Typeahead input
 */

import React from 'react'
import T from 'prop-types'
import MenuItem from './MenuItem'
import BoldSubstrings from './BoldSubstrings'
import fuzzaldrin from 'fuzzaldrin-plus'
// const fuzzaldrin = require('fuzzaldrin')


export default class TypeaheadOption extends React.Component {
  static displayName = 'TypeaheadOption'

  static propTypes = {
    onClick: T.func.isRequired,
    onMouseDown: T.func,
    option: T.shape({
      dividerAfter: T.bool,
      id: T.any.isRequired,
      menuItemContent: T.any, // optional, static element menu item. Matches not bolded
      getMenuItemContent: T.func, // optional, function returning React component to represent the option. Passed a single `matchedInnerHtml` argument, containing the bolded/matched innerHtml
      name: T.string // value displayed and matched against user input
    }),
    query: T.string, // Will bold the portions of option.name that match the query
    selected: T.bool,
    stopClickPropagation: T.bool,
    activeOptionId: T.any,
    readOnlyOption: T.bool
  }

  static defaultProps = {
    fastClick: false,
    selected: false,
    stopClickPropagation: false
  }

  _handleMouseDown = (e) => {
    const {
      onClick,
      option,
      stopClickPropagation
    } = this.props

    if (stopClickPropagation) {
      e.stopPropagation()
      e.preventDefault()
    }
    if (option && onClick) {
      onClick(option)
    }
  }

  _onClick = () => {
    // noop, handled in mousedown
  }

  _getBoldSubstring = () => {
    const { option, query } = this.props
    return (
      <BoldSubstrings
        boldIndices={fuzzaldrin.match(option.name, query)}
        text={option.name}
      />
    )
  }

  render() {
    const {
      option,
      query,
      selected,
      activeOptionId
    } = this.props

    return (
      <MenuItem
        allowActiveClick
        args={option}
        className={`typeahead_option typeahead_option_status_${option._status} ${selected
          ? 'active'
          : ''}`}
        dividerAfter={option.dividerAfter}
        headingText={option.headingText}
        onClick={this._onClick}
        active={activeOptionId && option.id ? activeOptionId === option.id : false}
        onMouseDown={this._handleMouseDown}
      >
        {option.getMenuItemContent
          ? option.getMenuItemContent(this._getBoldSubstring())
          : option.menuItemContent ||
            (query ? this._getBoldSubstring() : option.name)}
      </MenuItem>
    )
  }
}
